type HeaderProviderFn = () => Record<string, string> | Promise<Record<string, string>>;

let inflightPromise: Promise<Record<string, string>> | null = null;

export async function resolveProviderHeaders(
  provider?: HeaderProviderFn,
): Promise<Record<string, string>> {
  if (!provider) {
    return {};
  }
  if (inflightPromise) {
    return inflightPromise;
  }

  inflightPromise = Promise.resolve().then(() => provider());

  inflightPromise.finally(() => {
    queueMicrotask(() => {
      inflightPromise = null;
    });
  });

  return inflightPromise;
}

export function clearProviderHeadersCache(): void {
  inflightPromise = null;
}
